import { LogEvents } from '~/components/ClientExperience/services/logger/log-events';
import { ClientPortalConfigStore } from '~/components/ClientExperience/stores/client-portal-config.store';
import { FullstoryService } from '~/services/fullstory/fullstory.service';
import { S3ApiAdapter } from '~/components/ClientExperience/services/adapters/s3-api.adapter';
import { CompanyCXAdapter } from '~/components/ClientExperience/services/adapters/company-cx.adapter';

export class CompanyCXService extends CompanyCXAdapter {
    fullstoryService: FullstoryService;

    constructor({
        clientPortalConfigStore,
        fullstoryService,
        s3ApiAdapter
    }: {
        clientPortalConfigStore: ClientPortalConfigStore;
        fullstoryService: FullstoryService;
        s3ApiAdapter: S3ApiAdapter;
    }) {
        super({ clientPortalConfigStore, s3ApiAdapter });
        this.fullstoryService = fullstoryService;
    }

    async fetchCompanyBrandingData<ICompanyBrandingData>(placementId: string) {
        const { isPreview } = this.clientPortalConfigStore;

        if (isPreview) {
            return null;
        }

        try {
            return await super._fetchCompanyBrandingData<ICompanyBrandingData>(
                placementId
            );
        } catch {
            // In that case the user doesn't need this data and that's why
            // the data was never published to S3 so we init it with empty object.
            this.fullstoryService.warn(
                LogEvents.UserBrandingDataNotFound(placementId)
            );
            // We load empty object so it will still load the inactive page but without the branding data. The message
            // will still appear.
            return {};
        }
    }
}
